export default "__VITE_ASSET__Dyc2rhOz__"